import(/* webpackMode: "eager" */ "/vercel/path0/src/app/musicraft/artists/page.tsx");
